import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      id: '',
      name: '',
      document: '',
      email: '',
      role: ''
    },
    login: false
  },
  getters: {
    user(state) {
      return state.user
    },
    login(state) {
      return state.login
    }
  },
  mutations: {
    userData(state, payload) {
      state.user = payload
    },
    login(state, payload) {
      state.login = payload
    }
  },
  actions: {

  }
})
